// Vernacular labels used by the Advanced Diet Chart printout.
// Keep short — printed at small sizes.
export const DIET_LABELS = {
  en: {
    title:              "Advanced Diet Chart",
    plan_id:            "Plan ID",
    issued:             "Issued",
    patient_profile:    "Patient & condition profile",
    height:             "Height",  weight: "Weight",  waist: "Waist",
    ref_weight:         "Reference weight",
    prescription:       "Nutritional Prescription",
    energy:             "Energy",  protein: "Protein",  carbs: "Carbs",  fat: "Fat",
    sodium:             "Sodium",  salt_total: "Salt total",  fluid: "Fluid",
    fibre:              "Fibre",   cooking_oil: "Cooking oil",  meals: "Meals",
    loss_pace:          "Loss pace",  guidelines: "Guidelines",
    portion_glossary:   "Portion glossary",
    meal_plan:          "7-day meal plan",
    day:                "Day",
    breakfast:          "Breakfast",  lunch: "Lunch",  evening: "Evening",  dinner: "Dinner",  snacks: "Snacks",
    foods_to_avoid:     "Foods to avoid",
    category:           "Category",   items: "Items",
    electrolyte_guide:  "Electrolyte guidance (conditional)",
    drug_diet:          "Drug-diet interactions",
    monitoring:         "Monitoring & adjustment",
    parameter:          "Parameter",  frequency: "Frequency",
    emergency:          "Call the clinic immediately if any of these occur",
    issued_by:          "Issued by",
    disclaimer:         "This plan is individualised — modify only after clinician approval.",
    menu_unavailable:   "Menu not available.",
  },
  mr: {
    title:              "प्रगत आहार चार्ट",
    plan_id:            "योजना ID",
    issued:             "जारी",
    patient_profile:    "रुग्ण व स्थिती प्रोफाइल",
    height:             "उंची",  weight: "वजन",  waist: "कमर",
    ref_weight:         "संदर्भ वजन",
    prescription:       "पौष्टिक प्रिस्क्रिप्शन",
    energy:             "उर्जा",  protein: "प्रथिने",  carbs: "कार्बोहायड्रेट्स",  fat: "चरबी",
    sodium:             "सोडियम",  salt_total: "एकूण मीठ",  fluid: "पाणी",
    fibre:              "तंतू",   cooking_oil: "स्वयंपाकाचे तेल",  meals: "जेवण",
    loss_pace:          "वजन घटवण्याचा वेग",  guidelines: "मार्गदर्शक तत्त्वे",
    portion_glossary:   "प्रमाण मार्गदर्शन",
    meal_plan:          "७ दिवसांचा जेवण आराखडा",
    day:                "दिवस",
    breakfast:          "नाश्ता",  lunch: "दुपारचे",  evening: "संध्याकाळ",  dinner: "रात्रीचे",  snacks: "स्नॅक्स",
    foods_to_avoid:     "टाळण्याचे पदार्थ",
    category:           "श्रेणी",  items: "पदार्थ",
    electrolyte_guide:  "इलेक्ट्रोलाइट मार्गदर्शन (सशर्त)",
    drug_diet:          "औषध-आहार परस्परसंवाद",
    monitoring:         "निरीक्षण व सुधारणा",
    parameter:          "पॅरामीटर",  frequency: "वारंवारता",
    emergency:          "यापैकी कोणतीही लक्षणे आढळल्यास त्वरित क्लिनिकला कॉल करा",
    issued_by:          "जारी करणारे",
    disclaimer:         "ही योजना वैयक्तिकृत आहे — डॉक्टरांच्या मान्यतेशिवाय बदल करू नका.",
    menu_unavailable:   "मेनू उपलब्ध नाही.",
  },
  hi: {
    title:              "उन्नत आहार चार्ट",
    plan_id:            "योजना ID",
    issued:             "जारी",
    patient_profile:    "रोगी और स्थिति प्रोफ़ाइल",
    height:             "ऊँचाई",  weight: "वज़न",  waist: "कमर",
    ref_weight:         "संदर्भ वज़न",
    prescription:       "पोषण प्रिस्क्रिप्शन",
    energy:             "ऊर्जा",  protein: "प्रोटीन",  carbs: "कार्बोहाइड्रेट",  fat: "वसा",
    sodium:             "सोडियम",  salt_total: "कुल नमक",  fluid: "पानी",
    fibre:              "फ़ाइबर",   cooking_oil: "पकाने का तेल",  meals: "भोजन",
    loss_pace:          "वज़न घटाने की दर",  guidelines: "दिशानिर्देश",
    portion_glossary:   "मात्रा शब्दावली",
    meal_plan:          "7-दिन का भोजन प्लान",
    day:                "दिन",
    breakfast:          "नाश्ता",  lunch: "दोपहर",  evening: "शाम",  dinner: "रात्रि",  snacks: "स्नैक्स",
    foods_to_avoid:     "बचने वाले खाद्य",
    category:           "श्रेणी",  items: "पदार्थ",
    electrolyte_guide:  "इलेक्ट्रोलाइट मार्गदर्शन (सशर्त)",
    drug_diet:          "दवा-आहार परस्पर क्रिया",
    monitoring:         "निगरानी और समायोजन",
    parameter:          "पैरामीटर",  frequency: "आवृत्ति",
    emergency:          "इनमें से कोई भी लक्षण होने पर तुरंत क्लिनिक को कॉल करें",
    issued_by:          "जारीकर्ता",
    disclaimer:         "यह योजना व्यक्तिगत है — चिकित्सक की मंज़ूरी के बिना बदलाव न करें।",
    menu_unavailable:   "मेनू उपलब्ध नहीं।",
  },
};

export function dietLabels(lang) {
  return DIET_LABELS[lang] || DIET_LABELS.en;
}
